<template>
  <v-main>
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col class="ml-4" cols="3">
          <h2>
            Pick Five Best Projects
          </h2>
          If you knew the outcomes that you've just seen, which projects would
          you have selected in your portfolio? 
          <br>
          Please select the five projects out of all the projects (Unfunded & Funded) below that give the highest total value.
        </v-col>
        <v-col cols="3"></v-col>
        <v-col class="ml-4" cols="3">
          <h2>Summary:</h2>
          # of Projects Selected: {{ this.getNumberSelections }}
          <br />
          Total Value of Selection: {{ this.pick5Value }}
          <br />
          Value of Funded Projects: {{ sumField(this.funded, "value") }}
          <br />
          Value of Perfect Information: {{ this.getValuePerfectInfo }}
        </v-col>
      </v-row>
      <v-row>
        <v-col class="ml-4">
          <h3>Unfunded Projects</h3>
        </v-col>
        <v-col class="ml-4">
          <h3>Funded Projects</h3>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6">
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="unfunded"
            :dense="true"
            :single-select="singleSelect"
            item-key="id"
            hide-default-footer
            disable-sort
            class="elevation-1"
          >
            <template v-slot:item="{ item }">
              <tr
                :class="selected.indexOf(item.id) > -1 ? 'light-green' : ''"
                @click="rowClicked(item)"
              >
                <td>
                  <v-avatar>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-avatar>
                  {{ item.text }}
                </td>
                <td class="text-center">{{ item.rolled }}</td>
                <td class="text-center">{{ item.result }}</td>
                <td class="text-center">{{ item.value }}</td>
              </tr>
            </template>
            <template slot="body.append">
              <tr class="pink--text">
                <th></th>
                <th class="subtitle-1 text-center">Total</th>
                <th class="subtitle-1 text-center">
                  {{ sumSuccesses }}
                </th>
                <th class="subtitle-1 text-center">
                  {{ sumField(this.unfunded, "value") }}
                </th>
              </tr>
            </template>
          </v-data-table>
        </v-col>
        <v-col cols="6">
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="funded"
            :dense="true"
            :single-select="singleSelect"
            item-key="id"
            hide-default-footer
            disable-sort
            class="elevation-1"
          >
            <template v-slot:item="{ item }">
              <tr
                :class="selected.indexOf(item.id) > -1 ? 'light-green' : ''"
                @click="rowClicked(item)"
              >
                <td>
                  <v-avatar>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-avatar>
                  {{ item.text }}
                </td>
                <td class="text-center">{{ item.rolled }}</td>
                <td class="text-center">{{ item.result }}</td>
                <td class="text-center">{{ item.value }}</td>
              </tr>
            </template>
            <template slot="body.append">
              <tr class="pink--text">
                <th></th>
                <th class="subtitle-1 text-center">Total</th>
                <th class="subtitle-1 text-center">{{ sumSuccesses }}</th>
                <th class="subtitle-1 text-center">
                  {{ sumField(this.funded, "value") }}
                </th>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row v-if="advanceRoute" class="mr-2">
        <v-spacer></v-spacer>
        <v-btn :loading="false" color="#418F7B" text x-large @click="next">Next</v-btn>
      </v-row>
      <v-row v-else class="mr-2">
        <v-spacer></v-spacer>
        <v-btn :disabled="true" color="#951B20" text>
          Please Wait For Game to advance
        </v-btn>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
export default {
  data() {
    return {
      singleSelect: false,
      selected: [],
      pick5Value: 0,
      headers: [
        {
          text: "Project",
          sortable: false,
          value: "projects",
          class: "title"
        },
        {
          text: "Dice Roll",
          sortable: false,
          value: "diceRoll",
          class: "title",
          align: "center"
        },
        {
          text: "Result",
          sortable: false,
          value: "result",
          class: "title",
          align: "center"
        },
        {
          text: "Value",
          sortable: false,
          value: "value",
          class: "title",
          align: "center"
        }
      ]
    };
  },

  computed: {
    getNumberSelections() {
      return this.selected.length;
    },

    getValuePerfectInfo() {
      if (this.pick5Value > this.sumField(this.funded, "value"))
        return this.pick5Value - this.sumField(this.funded, "value");
      else return 0;
    },

    rollSuccesses() {
      let cnt = 0;
      for (const item of this.funded.slice(0, 5)) {
        if (item.result === "Success") {
          cnt++;
        }
      }
      return cnt;
    },
    getRolls() {
      let cnt = 0;
      for (const item of this.funded) {
        if (item.result) cnt++;
      }
      return cnt;
    },
    sumSuccesses() {
      return this.rollSuccesses.toString() + "/" + this.getRolls.toString();
    },

    unfunded() {
      return this.$store.getters.projects.filter(
        element => element.funded === false
      );
    },
    projects() {
      return this.$store.getters.projects;
    },

    funded() {
      return this.$store.getters.projects.filter(
        element => element.funded === true
      );
    },
    advanceRoute() {
      return this.$store.getters.advanceRoute(this.$route.path);
    }
  },
  methods: {
    next() {
      this.$router.push("bestfivereview");
    },
    rowClicked: function(row) {
      // alert(row.id)
      console.log("Row Selected:  ", row);
      if (row.id < 20) {
        this.toggleSelection(row.id);
      }
    },
    sumField(items, key) {
      return items.reduce((a, b) => a + (b[key] || 0), 0);
    },
    toggleSelection(keyID) {
      if (this.selected.includes(keyID)) {
        this.selected = this.selected.filter(
          selectedKeyID => selectedKeyID !== keyID
        );
        const selectedProject = this.projects.find(obj => obj.id === keyID)
        this.pick5Value -= selectedProject.value;
      } else if (this.selected.length < 5) {
        const selectedProject = this.projects.find(obj => obj.id === keyID)
        this.pick5Value += selectedProject.value;
        this.selected.push(keyID);
      }
    }
  }
};
</script>

<style>
tr.v-data-table__selected {
  background: #7d92f5 !important;
}
</style>
